module.exports = __webpack_public_path__ + "static/media/image95.388b4b19.png";